import { apiClient } from './client';

export interface TenantFeatures {
  demoEnabled: boolean;
  featureFlags?: Record<string, boolean>;
}

/**
 * Feature flags del tenant (autenticado): lo usa el Sidebar después del login.
 * Sin tenantId en la URL: el interceptor de client.ts inyecta el de la sesión. Armarla
 * con el tenantId de la ruta (código/slug) la reescribía a /api/<UUID>/<slug>/... -> 404.
 */
export async function getTenantFeatures(): Promise<TenantFeatures> {
  const res = await apiClient.get<TenantFeatures>('/api/tenant-features');
  return res.data;
}

export interface TenantConfig {
  /** La pantalla de acceso muestra el botón demo solo si esto es true (pre-login). */
  demoEnabled: boolean;
  logoUrl?: string;
  displayName: string;
  /** Largo mínimo de contraseña de la empresa (passwordPolicy.minLength; 8 si no hay política). */
  passwordMinLength?: number;
}

export async function getTenantConfig(tenantId: string): Promise<TenantConfig> {
  const res = await apiClient.get<TenantConfig>(`/api/tenant/${tenantId}/config`);
  return res.data;
}
